import { useState, useEffect } from 'react';
import { getCurrentShift, openShift, closeShift, type Shift } from '../api/shifts.api'; // Ensure path is correct

export const useShift = () => {
    const [shift, setShift] = useState<Shift | null>(() => {
        // Inicializar desde localStorage para carga inmediata (offline/multi-tab friendly)
        const stored = localStorage.getItem('activeShift');
        return stored ? JSON.parse(stored) : null;
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadShift();

        // Sincronizar estado entre pestañas
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === 'activeShift') {
                const newValue = e.newValue ? JSON.parse(e.newValue) : null;
                setShift(newValue);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    const loadShift = async () => {
        try {
            const data = await getCurrentShift();
            setShift(data);
            if (data) {
                localStorage.setItem('activeShift', JSON.stringify(data));
            } else {
                localStorage.removeItem('activeShift');
            }
        } catch (error) {
            console.error('Error loading shift:', error);
            // Si hay error de red, mantenemos lo que hay en el estado (que vino del localStorage)
        } finally {
            setLoading(false);
        }
    };

    const handleOpenShift = async (monto: number) => {
        try {
            const newShift = await openShift({ montoInicial: monto });
            setShift(newShift);
            localStorage.setItem('activeShift', JSON.stringify(newShift));
            return true;
        } catch (error) {
            console.error('Error opening shift:', error);
            return false;
        }
    };

    const handleCloseShift = async (efectivoContado: number, observaciones?: string) => {
        try {
            const closedShift = await closeShift({ efectivoContado, observaciones });
            setShift(null); // No hay turno activo
            localStorage.removeItem('activeShift');
            return closedShift; // Retornamos para mostrar resumen si se quiere
        } catch (error) {
            console.error('Error closing shift:', error);
            throw error;
        }
    };

    return { shift, loading, handleOpenShift, handleCloseShift, refreshShift: loadShift };
};
